function slide({ holder, prev, i, idx }) {
  const current = holder.querySelector(".active");
  let next;

  if (idx || idx == 0) {
    next = holder.querySelector(`.slide[data-id="${idx}"]`);
  } else if (prev) {
    next = current.previousElementSibling
      ? current.previousElementSibling
      : holder.querySelector(".slide:last-child");
  } else {
    next =
      current.nextElementSibling &&
      !/dots/gi.test(current.nextElementSibling.getAttribute("class"))
        ? current.nextElementSibling
        : holder.querySelector(".slide:first-child");
  }
  let timer = 0;
  if (prev) {
    timer = 50;
    next.classList.add("reset-to-left");
  }

  setTimeout(() => {
    next.classList.remove("reset-to-left");
    next.classList.add("active");
    holder.querySelector(
      `.dot input[value="${next.getAttribute("data-id")}"]`
    ).checked = true;
    current.classList.add(`slide-out${prev ? "-right" : ""}`);
    current.classList.remove("active");
    setTimeout(() => {
      current.classList.remove(`slide-out${prev ? "-right" : ""}`);
      clicked[i] = false;
    }, 1000);
  }, timer);
}

const intervals = [];
const clicked = [];

function init() {
  const holders = document.querySelectorAll(".slider-holder");
  const time = 5000;
  holders.forEach((holder, i) => {
    if (holder.querySelectorAll(".slide").length) {
      let dots = [];
      clicked[i] = false;
      let prev = false;

      holder
        .querySelectorAll(".slide")
        .forEach((slide, idx) =>
          dots.push(
            `<label class="dot" for="slider-${i}-slide-${idx}" aria-label="Näytä slide ${idx}"><input type="radio" value="${idx}" name="slider-${i}" id="slider-${i}-slide-${idx}" /><span></span></label>`
          )
        );
      holder.querySelector(".dots").innerHTML = dots.join("");
      holder.querySelector(".dot:first-child input").checked = true;
      holder.querySelectorAll(".dot input").forEach(dot =>
        dot.addEventListener("change", () => {
          const active = +holder
            .querySelector(".active")
            .getAttribute("data-id");

          if (!clicked[i] && +dot.value != active) {
            clicked[i] = true;
            clearInterval(intervals[i]);

            prev = +dot.value < +active ? true : false;

            slide({ holder, prev, i, idx: +dot.value });
            intervals[i] = setInterval(() => {
              slide({ holder, prev: false, i });
            }, time);
          }
        })
      );
      holder
        .querySelector("button:first-child")
        .addEventListener("click", () => {
          if (!clicked[i]) {
            clicked[i] = true;
            prev = true;
            clearInterval(intervals[i]);
            slide({ holder, prev, i });
            intervals[i] = setInterval(() => {
              slide({ holder, prev, i });
            }, time);
          }
        });
      holder
        .querySelector("button:first-child + button")
        .addEventListener("click", () => {
          if (!clicked[i]) {
            clicked[i] = true;
            prev = false;
            clearInterval(intervals[i]);
            slide({ holder, prev, i });
            intervals[i] = setInterval(() => {
              slide({ holder, prev, i });
            }, time);
          }
        });
      intervals[i] = setInterval(() => {
        slide({ holder, prev, i });
      }, time);
    }
  });
}
module.exports = { init };
